import { API } from "aws-amplify";
import useSWR from "swr";

const apiName = "getStripeItems";
const BUNDLES = ["advent-calendar-2022", "advent-calendar-2025"];

const buildEndpoint = (bundleId) =>
  `/products?bundleId=${encodeURIComponent(bundleId)}`;

export const useIndividualLessons = () => {
  const getItems = async () => {
    const responses = await Promise.all(
      BUNDLES.map((bundleId) => API.get(apiName, buildEndpoint(bundleId))),
    );

    const merged = responses.flatMap((r) => r?.items ?? []);
    const seen = new Set();
    const lessons = merged.filter((item) => {
      const key = item?.id;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    return { lessons };
  };

  const swrKey = `${apiName}/products?bundleIds=${BUNDLES.join(",")}`;
  const { data } = useSWR(swrKey, getItems);

  return data;
};
